<template>
	<div>
		<transition name="modal">
			<div class="modal-mask">
				<div class="modal-wrapper" @click="$emit('closeModal')">
					<div class="row">
						<div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
						<div class="col-xs-12 col-sm-12 col-md-10 col-lg-10">
							<div class="modal-container" @click.stop>

                <div class="modal-header row" style="justify-content: flex-end;">
                  <div class="col">
                    <button type="button" class="close" @click="$emit('closeModal')">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                </div>

								<div class="modal-body">
                  <h1 class="text-center mt-3 mb-4">Pilih Work Order</h1>
                  
                  <div class="row">
                    <div class="col">
                      <panel class="border border-secondary" :noExpand="true">
                        <template slot="header">
                          <h4 class="panel-title">Filter</h4>
                        </template>
                        <div class="row outerBox filterBox" style="padding:0">
                          <div class="col row">
                            <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
                              <label for="partshopCode">Cari</label>
                              <input type="text" class="form-control" placeholder="Ketik teks" style="height: 43px;" v-model="filter.search">
                            </div>
                            <div class="col-md-4" :class="mobile ? 'pt-20' : ''">
                              <label for="partshopCode">Tanggal</label>
                              <flat-pickr
                                v-model="selected.date"
                                :config="rangeConfig"
                                placeholder="Pilih Tanggal"
                              ></flat-pickr>
                            </div>
                            <div class="col-md-4" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
                              <button type="button" class="btn btn-primary" style="height:38px; margin-bottom:0.5%" @click="vue_universal_table.update++">Filter</button>
                            </div>
                          </div>
                        </div>
                      </panel>

                      <vue-universal-table
                        api_url="/api/v1/workorder/listing"
                        :buttons="vue_universal_table.buttons"
                        :filter="filter"
                        :fields="vue_universal_table.fields"
                        :update="vue_universal_table.update"
                        :process_data='vue_universal_table.process_data'
                        :limit_per_page="5"
                        :disable_limit_per_page="true"
                        @onPengaduan="complainWorkOrder"
                      ></vue-universal-table>
                    </div>
                  </div>
                </div>
                
							</div>
						</div>
						<div class="col-xs-0 col-sm-0 col-md-1 col-lg-1"></div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
  import moment from 'moment'
  
  export default {
    data () {
      const start = moment().add('-6' , 'month').startOf('month').format('YYYY-MM-DD');
      let end  = new moment().format('YYYY-MM-DD')

      return {
        mobile : this.isMobile(),
        selected : {
          date : `${start} to ${end}`,
        },
        filter: {
          start: start,
          end: end,
          search : '',
          completed : true
        },
        rangeConfig: {
          mode: 'range',
          altInput: true,
          altInputClass: 'form-control input flatpickr-input w-100',
          animate: !this.isRTL()
        },
        vue_universal_table : {
          update: 0,
          buttons : [
            {
              title : 'pengaduan',
              variable : 'form_code',
              class : 'btn-outline-danger fas fa-file'
            }
          ],
          process_data : `
            for (var i in data) { 
              data[i].log_name = data[i].log ? data[i].log.name : '-'
              data[i].step_name = data[i].step ? data[i].step.name : '-'
            }`,
          fields : [
            {
              title : 'Work Order ID',
              variable : 'form_code'
            },
            {
              title : 'Nama Pelanggan',
              variable : 'customer_name'
            },
            {
              title : 'Status Mobil',
              variable : 'log_name'
            },
            {
              title : 'Step Pekerjaan Terakhir',
              variable : 'step_name'
            },
            {
              title : 'Dibuat Pada',
              variable : 'created_at'
            },
            {
              title : 'No Polisi',
              variable : 'registration'
            },
            {
              title : 'CSO',
              variable : 'CSO'
            }
          ]
        }
      }
    },
    mounted () {

    },
    watch : {
      'selected.date' : function () {
        let date = this.selected.date;
        if(date.includes('to')) {
          date = date.split(' to ')
          this.filter.start = date[0]
          this.filter.end = date[1]
        }
        else {
          this.filter.start = this.filter.end = date
        }
        

      }
    },
    methods : {
      complainWorkOrder (x) {
        this.$router.push({name : 'ComplainView', params: {id : x.replace(/"/g, "")}})
      }
    }
  }
</script>